import React from 'react';
import Card from '../components/common/Card';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto py-12 px-4 space-y-8">
        {/* Header */}
        <section className="text-center">
          <h1 className="text-xl sm:text-2xl font-bold text-emphasis mb-4">Terms of Service</h1>
          <p className="text-secondary">Last updated: March 2024</p>
        </section>

        {/* Content */}
        <Card className="p-8">
          <div className="prose prose-sm max-w-none">
            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">1. Agreement to Terms</h2>
              <p className="text-secondary mb-3">
                By accessing or using our platform, you agree to be bound by these Terms of Service ("Terms"). If you disagree with any part of these terms, then you do not have permission to access the platform.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">2. Intellectual Property</h2>
              <p className="text-secondary mb-3">
                The Platform and its original content, features, and functionality are and will remain the exclusive property of SALON and its licensors. The Platform is protected by copyright, trademark, and other laws of both the United States and foreign countries.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">3. User Accounts</h2>
              <p className="text-secondary mb-3">When you create an account with us, you guarantee that:</p>
              <ul className="list-disc list-inside text-secondary space-y-2 ml-4 mb-3">
                <li>The information you provide us is accurate, complete, and current at all times</li>
                <li>You are at least 18 years of age</li>
                <li>You have the legal capacity to enter into a binding agreement</li>
                <li>You will not use the platform for any unlawful purpose or in violation of these Terms</li>
              </ul>
              <p className="text-secondary mb-3">
                We reserve the right to suspend or terminate your account if any information provided proves to be inaccurate, not current, or incomplete at any time.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">4. Booking and Payments</h2>
              <p className="text-secondary mb-3">By making a booking through our platform:</p>
              <ul className="list-disc list-inside text-secondary space-y-2 ml-4 mb-3">
                <li>You agree to provide accurate booking information</li>
                <li>You authorize us to charge the payment method you provide for the total booking amount</li>
                <li>You agree to arrive at your scheduled appointment on time</li>
                <li>You understand that cancellations may be subject to our cancellation policy</li>
              </ul>
              <p className="text-secondary mb-3">
                Service providers are independent contractors and are not employees of SALON. We are not responsible for the quality, timing, or conduct of any services provided by third-party service providers.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">5. User Content</h2>
              <p className="text-secondary mb-3">
                Our Platform allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material ("Content"). You are responsible for the Content that you post to the Platform, including its legality, reliability, and appropriateness.
              </p>
              <p className="text-secondary mb-3">
                By posting Content to the Platform, you grant us the right and license to use, modify, publicly perform, publicly display, reproduce, and distribute such Content on and through the Platform.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">6. Prohibited Uses</h2>
              <p className="text-secondary mb-3">You may not use the platform:</p>
              <ul className="list-disc list-inside text-secondary space-y-2 ml-4 mb-3">
                <li>In any way that violates any applicable federal, state, local, or international law or regulation</li>
                <li>To engage in any data mining, data harvesting, data extracting or any other similar activity in relation to this Platform</li>
                <li>To transmit any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation</li>
                <li>To impersonate or attempt to impersonate the Company, a Company employee, another user, or any other person or entity</li>
                <li>To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Platform</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">7. Disclaimer of Warranties</h2>
              <p className="text-secondary mb-3">
                YOUR USE OF THE PLATFORM IS AT YOUR SOLE RISK. THE PLATFORM IS PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS. THE COMPANY MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THEIR SERVICES, OR THE INFORMATION, CONTENT, OR MATERIALS INCLUDED THEREIN.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">8. Limitation of Liability</h2>
              <p className="text-secondary mb-3">
                IN NO EVENT SHALL THE COMPANY, NOR ITS DIRECTORS, EMPLOYEES, PARTNERS, AGENTS, SUPPLIERS, OR AFFILIATES, BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF PROFITS, DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES, RESULTING FROM (I) YOUR ACCESS TO OR USE OF OR INABILITY TO ACCESS OR USE THE PLATFORM; (II) ANY CONDUCT OR CONTENT OF ANY THIRD PARTY ON THE PLATFORM; (III) ANY CONTENT OBTAINED FROM THE PLATFORM; AND (IV) UNAUTHORIZED ACCESS, USE OR ALTERATION OF YOUR TRANSMISSIONS OR CONTENT.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">9. Indemnification</h2>
              <p className="text-secondary mb-3">
                You agree to defend, indemnify, and hold harmless the Company and its licensee and licensors, and their employees, contractors, agents, officers, and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Platform, or b) a breach of these Terms.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">10. Governing Law</h2>
              <p className="text-secondary mb-3">
                These Terms shall be governed and construed in accordance with the laws of the State of New York, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">11. Changes to Terms</h2>
              <p className="text-secondary mb-3">
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our Platform after any revisions become effective, you agree to be bound by the revised terms.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-xl font-bold text-emphasis mb-3">12. Contact Us</h2>
              <p className="text-secondary mb-3">
                If you have any questions about these Terms, please contact us:
              </p>
              <ul className="list-disc list-inside text-secondary space-y-2 ml-4">
                <li>By email: legal@salon.com</li>
                <li>By visiting our contact page: /contact</li>
              </ul>
            </section>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;
